module.exports = __webpack_public_path__ + "img/photo3_7.d8d5c967.jpg";